import React from "react";

export const Minus = ({ viewBox="0 0 16 14", width="16", height="14", strokeWidth="1.5" }) => {
    return (
        <svg viewBox={viewBox} width={width} height={height} stroke="#222" strokeWidth={strokeWidth} fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Icons">
                <path id="Vector" d="M0.99993 7.00001H15.0001" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    )
}